// extracted by mini-css-extract-plugin
module.exports = {"container":"Slideshow-module--container--1I7wv","slide":"Slideshow-module--slide--vswCg"};